import {constants} from '../../../redux/constants'
import {ILegalState} from './reducers'

export const legalActions = {
  setState: (state: ILegalState) => ({
    type: constants.SET_LEGAL_STATE,
    state,
  }),
}
